export default [
  {
    title: 'Check Balance & Transaction',
    customicon: '<span class="k-home-hashtag text-lg mr-[10px] "  />',
    tagVariant: 'light-warning',
    resource: 'OverviewMonitoring',
    route: 'monitoring-check-balance-transaction',
    action: 'manage',
  },
]
